import { io } from "socket.io-client";

const socket = io(
  process.env.REACT_APP_API_BASE_URL || "https://mdk7v2f6-5000.inc1.devtunnels.ms",
  {
    transports: ["websocket"],
    autoConnect: true,
    withCredentials: true,
  }
);

export default socket;
